import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ErrorHandlingService, JwtService, LocalStorageService } from '../services/index.service';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtTokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(
    private jwtService:JwtService,
    private storageService:LocalStorageService,
    private router:Router,
    private errorHandlingService:ErrorHandlingService
  ) {}

  intercept(request: HttpRequest<any> , next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.storageService.getData('token')
    if(token){
      this.jwtService.distributionToken(token)
      request = this.addTokenHeader(request,this.jwtService.getAccessToken())
      return next.handle(request).pipe(catchError((error:any) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          if(request.url.includes('auth/jwt/refresh/')) this.logout()
          return this.handle401Error(request, next);
        }
  
        return throwError(error);
      }));
    }else{
      request = request.clone({
        setHeaders:{
          'Accept-Language':'fa'
        }
      })
      return next.handle(request)
    }
    
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const token = this.jwtService.getRefreshToken();
      if (token){
        return this.jwtService.refreshToken(token).pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;
            this.jwtService.distributionToken(token);
            this.jwtService.login();
            this.refreshTokenSubject.next(this.jwtService.getAccessToken());
            
            return next.handle(this.addTokenHeader(request, this.jwtService.getAccessToken()));
          }),
          catchError((err) => {
            if(err.status==500 || err.status==502 || err==0 || err.status==0){
              this.jwtService.setErrorServerStatus(true,this.errorHandlingService.getErrorObj(err))
            }
            this.isRefreshing = false;
            // this.logout();
            return throwError(err);
          })
        );
      }
    }

    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }
  private addTokenHeader(request: HttpRequest<any>, token: any) {    
    return request.clone({
      setHeaders:{
        'Authorization': `Bearer ${token}`,
        'Accept-Language':'fa',
        // 'Access-Control-Allow-Origin': '*'
      }
    });
  }
  private logout(){
    this.storageService.removeItem('token')
    this.storageService.removeItem('identity')
    this.router.navigate(['/auth/login'])
    window.scroll(0,0);
    this.jwtService.logout()
  }
}
